export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/Core/Components/HttpConfigurationAdminConsoleComponent.vue'),
    contentData: {
        key: 'HttpConfigurationAdminConsole',
        visible: true
    }
};